import styled from 'styled-components';

export default function FormSection() {
  return (
    <>
      <FormWrap>
        <div className="inner">
          <div className="terms-box">
            <h4>Terms and conditions of consent to collect and use personal information</h4>
            <div className="terms-content">
              <p style={{ whiteSpace: "pre-line" }}>
                {`* Purpose of Collection and Use of Personal Information
                - Identification according to the use of the service, identification of real name, confirmation of intention to join, and use of age-restricted services
                - Deliver notices, secure communication channels for handling complaints, and secure accurate delivery destination information when delivering goods
                - Data for providing updated information such as new services and personalized services
                - Providing other smooth, high-quality services, etc
                                
                                * Items of personal information to be collected
                - Name, e-mail, resident registration number, address, contact information, mobile phone number, and other options
                
                * Period of retention and use of personal information
                - In principle, personal information is collected or destroyed without delay when achieving the purpose provided.
                - However, for smooth service consultation, the contents can be retained for three months after completion of the consultation
                   If it is necessary to preserve it under other laws, such as the Consumer Protection Act in Electronic Commerce, it shall be preserved for a certain period of time.`}
              </p>
            </div>
          </div>
        </div>
      </FormWrap>
    </>
  )
}

const LoadWrap = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loader {
    border: 6px solid #f3f3f3;
    border-top: 6px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 0.8s linear infinite;
  }
`

const FormWrap = styled.section`
  position: relative;
  padding: 100px 0;
  text-align: center;

  .form-box {
    margin-top: 45px;
    position: relative;
    display: flex;

    .contact-form {
      flex: 2.5;
      position: relative;
      padding: 20px;
      background: rgba(0, 114, 185, 0.1);

      .form-head {
        position: relative;
        text-align: left;

        .form-tit {
          position: relative;

          strong {
            display: inline-block;
            font-weight: 400;
            font-size: 24px;
            line-height: 1.2;
            color: #000;
            border-bottom: 1px solid #000;
          }
        }

        ul {
          margin: 10px 0 0 20px;
          position: relative;

          li {
            list-style: disc;

            font-weight: 400;
            font-size: 12px;
            line-height: 1.2;
            color: #000;
          }
        }
      }

      .form-desc {
        margin-top: 50px;
        position: relative;

        .input-desc {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0 60px;

        }

        .input-full {
          position: relative;
        }

        .input-in {
          position: relative;
          flex: 1;

          &.contact-name {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_user.svg') top 50% left 10px no-repeat;
          }

          &.contact-phone {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_phone.svg') top 50% left 10px no-repeat;
          }

          &.contact-mail {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_mail.svg') top 50% left 10px no-repeat;
          }

          &.contact-city {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_place.svg') top 50% left 10px no-repeat;
          }

          &.contact-pest {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_insect.svg') top 50% left 10px no-repeat;
          }

          &.contact-type {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_type.svg') top 50% left 10px no-repeat;
          }

          &.contact-address {
            background: transparent url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/contact/contact_address.svg') top 50% left 10px no-repeat;
          }

          label {
            display: none;
          }

          input, select {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: transparent;
            border: 1px solid #0072B9;
            padding: 0 20px 0 50px;
            font-weight: 500;
            font-size: 18px;
            color: #0072B9;

            &::placeholder {
              color: #0072B9;
            }

            &#contact-inquiry {
              padding: 0 20px;
            }

          }

          select {
            background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/common/select_drop.svg') top 50% right 5px no-repeat;
          }
        }

        button {
          margin-top: 30px;
          display: inline-block;
          padding: 0 30px;
          height: 50px;
          line-height: 50px;
          background: transparent;
          border: 1px solid #0072B9;
          border-radius: 30px;
          font-weight: 500;
          font-size: 16px;
          color: #0072B9;
          transition: all .3s ease-in;

          &:hover {
            background: #0072B9;
            color: #ffffff;
          }
        }

        > div + div {
          margin-top: 20px;
        }
      }
    }

    .contact-info {
      flex: 1;
      position: relative;
      padding: 20px;
      border: 3px solid #0072B9;

      > strong {
        display: inline-block;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.2;
        color: #000;
        border-bottom: 1px solid #000;
      }

      .info-list {
        margin-top: 30px;

        .info-item {
          position: relative;
          display: flex;
          align-items: center;
          padding: 20px 0;

          .info-desc {
            text-align: left;

            strong {
              font-weight: 700;
              font-size: 28px;
              color: #000;
            }

            ul {
              margin-top: 10px;

              li {
                font-weight: 400;
                font-size: 18px;
                line-height: 1.5;
                color: #000;
              }
            }
          }
        }

        .info-item + .info-item {
          border-top: 1px solid #0072B9;
        }
      }
    }
  }
  
  .terms-box {
    margin-top:45px;
    
    h4 {
      font-weight:500;
      font-size:24px;
      line-height:1.2;
    }
    
    .terms-content {
      margin-top:20px;
      position:relative;
      padding:25px;
      border:1px solid #111;
      
      p {
        font-size:1.2rem;
        font-weight:400;
        line-height:1.5;
        text-align:left;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    padding: 50px 0;

    .form-box {
      display: block;

      .contact-form {
        width: 100%;

        .form-head {
          position: relative;
          text-align: left;

          .form-tit {
            position: relative;

            strong {
              display: inline-block;
              font-weight: 400;
              font-size: 24px;
              line-height: 1.2;
              color: #000;
              border-bottom: 1px solid #000;
            }
          }

          ul {
            margin: 10px 0 0 20px;
            position: relative;

            li {
              list-style: disc;

              font-weight: 400;
              font-size: 12px;
              line-height: 1.2;
              color: #000;
            }
          }
        }

        .form-desc {
          margin-top: 20px;

          .input-desc {
            display: block;
          }

          .input-in {
            position: relative;
            flex: 1;

            label {
              display: none;
            }

            input, select {
              padding: 0 30px 0 50px;
              font-size: 16px;
            }

            &.input-in + .input-in {
              margin-top: 20px;
            }
          }

          > div + div {
            margin-top: 20px;
          }
        }
      }

      .contact-info {
        margin-top: 45px;
        width: 100%;

        > strong {
          display: inline-block;
          font-weight: 400;
          font-size: 20px;
          line-height: 1.2;
          color: #000;
          border-bottom: 1px solid #000;
        }

        .info-list {
          margin-top: 15px;

          .info-item {
            flex: 1;

            .info-desc {
              width: 100%;
              text-align: center;

              strong {
                font-size: 18px;
              }

              ul li {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
`
